// extracted by mini-css-extract-plugin
module.exports = {"container":"Synthesis_container__3g7LU","synthesis":"Synthesis_synthesis__1jP7F"};